/* eslint-disable import/no-anonymous-default-export */
export default {
  API: {
    ARTISTS: {
      ADD_ARTIST: "/artist/AddArtist",
      DELETE_ARTIST: "/artist/DeleteArtist",
      EDIT_ARTIST: "/artist/EditArtist",
      GET_ALL_ARTISTS: "/artist/GetAllArtists",
      GET_ALL_ARTISTS_SPOTIFY_IDS: "/artist/GetAllArtistsSpotifyIds",
      GET_TOTAL_ARTISTS_COUNT: "/artist/GetTotalArtistsCount",
    },
    AWS: {
      DELETE_OBJECT: "/aws/DeleteObject",
      GET_BACKGROUND_VIDEOS: "/aws/GetBackgroundVideos",
    },
    BLOG: {
      ADD_BLOG_POST: "/blog/AddBlogPost",
      ADD_BLOG_POST_IMAGE: "/blog/AddBlogPostImage",
      DELETE_BLOG_POST: "/blog/DeleteBlogPost",
      EDIT_BLOG_POST: "/blog/EditBlogPost",
      GET_ALL_BLOG_POSTS: "/blog/GetAllBlogPosts",
      GET_BLOG_POST_BY_ID: "/blog/GetBlogPostById",
    },
    FAQ: {
      ADD_FAQ: "/faq/AddFAQ",
      DELETE_FAQ: "/faq/DeleteFAQ",
      GET_ALL_FAQS: "/faq/GetAllFAQs",
      GET_FAQ_BY_ID: "/faq/GetFAQById",
    },
    GENERAL: {
      ADD_SITE_VIEW: "/general/AddSiteView",
      GET_SITE_VIEW_COUNT: "/general/GetSiteViewCount",
    },
    MAIL: {
      SUBMIT_CONTACT_FORM: "/mail/SubmitContactForm",
      SUBMIT_HELP_REQUEST: "/mail/SubmitHelpRequest",
    },
    SPOTIFY: {
      GET_ARTISTS: "/spotify/GetArtists",
      GET_ARTIST_DATA: "/spotify/GetArtistData",
      GET_ARTIST_ALBUMS: "/spotify/GetArtistAlbums",
    },
    USERS: {
      ADD_USER: "/user/AddUser",
      CHANGE_PASSWORD: "/user/ChangePassword",
      DELETE_USER: "/user/DeleteUser",
      EDIT_USER: "/user/EditUser",
      GENERATE_TEMPORARY_PASSWORD: "/user/GenerateTemporaryPassword",
      GET_ALL_USERS: "/user/GetAllUsers",
      GET_TOTAL_USER_COUNT: "/user/GetTotalUserCount",
      GET_USER_BY_EMAIL: "/user/GetUserByEmail",
      LOGIN: "/user/Login",
      LOGOUT: "/user/Logout",
      ME: "/user/Me",
      RESET_PASSWORD: "/user/ResetPassword",
      UPDATE_ACCOUNT: "/user/UpdateAccount",
    },
  },
  SPOTIFY_ENDPOINT: "https://api.spotify.com/v1/artists?ids={ids}",
  YOUTUBE_VIDEO_HREF: "https://www.youtube-nocookie.com/embed/{videoId}",
  YOUTUBE_STATISTICS_ENDPOINT:
    "https://youtube.googleapis.com/youtube/v3/channels?part=statistics&id={channelId}&key={apiKey}",
  YOUTUBE_RECENT_VIDEO_ENDPOINT:
    "https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId={playlistId}&key={apiKey}",
};
